<template>
  <div v-if="task">
    <v-card class="ma-2" height="100%">
      <v-layout row wrap>
        <v-flex xs12>
          <v-toolbar class="boxToolbar" flat :class="statusColors()" height="50px">
            <v-toolbar-title class="font-weight-bold display-1">{{ task.name }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn dark flat icon @click="closeDialog"><v-icon>cancel</v-icon></v-btn>
          </v-toolbar>
          <div :class="statusColors()" class="pl-4 pb-1">{{ project.name }} #{{ project.job_number }}</div>
          <div class="pt-3 pb-2 pr-3 grey lighten-3" >
            <v-layout row wrap>
              <v-flex xs12 sm6>
                <v-btn :disabled="!canEdit" @click="showDueDateDialog = true" flat :class="task.status === 'Completed' ? 'completed' 
                : ((task.due_date.seconds * 1000) - new Date().getTime()) / 84600000 < 0 ? 'pastDue' 
                : ((task.due_date.seconds * 1000) - new Date().getTime()) / 84600000 < 3 && ((task.due_date.seconds * 1000) - new Date().getTime()) / 84600000 > -1 ? 'currentDue' : 'notDue'"><v-icon large class="pr-2">today</v-icon>
                <span class="subheading font-weight-bold" :class="task.status === 'Completed' ? 'completed' 
                : ((task.due_date.seconds * 1000) - new Date().getTime()) / 84600000 < 0 ? 'pastDue' 
                : ((task.due_date.seconds * 1000) - new Date().getTime()) / 84600000 < 3 && ((task.due_date.seconds * 1000) - new Date().getTime()) / 84600000 > -1 ? 'currentDue' : 'notDue'">
                  <span v-if="task.status === 'Completed'">Completed {{task.completed_date.seconds | moment("from")}}
                    <span class="caption font-weight-bold text--secondary ml-2">{{task.completed_date.seconds | moment("MMMM Do YYYY")}}</span>
                  </span>
                  <span v-if="task.status !== 'Completed' && !task.after_task">Due {{task.due_date.seconds | moment("from")}}
                    <span class="caption font-weight-bold text--secondary ml-2">{{task.due_date.seconds | moment("MMMM Do YYYY")}}</span>
                  </span>
                  <span class="caption" v-if="task.status !== 'Completed' && task.after_task">Due {{task.days_due}} days after: {{task.after_task_name}}
                    <span class="caption font-weight-bold text--secondary ml-2">{{task.due_date.seconds | moment("MMMM Do YYYY")}}</span>
                  </span>
                </span>
                </v-btn>
                <v-layout row>
                  <v-btn :disabled="!canEdit" flat @click="vendorSearch = true"><v-icon large class="pr-2" color="grey">assignment_ind</v-icon>Vendor: {{task.vendor_name ? task.vendor_name : 'No Vendor Assigned'}}</v-btn>
                  <v-btn @click="removeVendor" v-if="canEdit && task.vendor_id" flat icon><v-icon color="grey">cancel</v-icon></v-btn>
                </v-layout>
              </v-flex>
              <v-flex xs12 sm6 pt-2 class="text-xs-right">
                <v-menu offset-y>
                  <v-btn :disabled="!canEdit" @click="statusActivate(task)" slot="activator" large outline :color="task.status.replace(' ', '')">{{ task.status }}</v-btn>
                  <v-list class="text-xs-center" style="background-color: rgba(255, 255, 255, 0.95)">
                    <v-flex v-for="(status, index) in statusDropDown(task)" :key="index">
                      <v-btn :disabled="!canEdit" @click="taskExecution(status)" class="text-xs-center" small outline :color="status.replace(' ', '')">{{ status }}</v-btn>
                    </v-flex>
                  </v-list>
                </v-menu>
                <v-tooltip max-width="300px" bottom>
                  <v-btn v-if="task.status != 'Completed'" slot="activator" @click="completeTask" :disabled="!canEdit || cannotComplete" large flat class="success">Completed</v-btn>
                  <span v-if="cannotComplete" class="subheading">You can not mark this complete until you have completed all checklist items and uploaded any required files.</span>
                </v-tooltip>
              </v-flex>
              <!-- Identifies if the vendor is double booked on another project on the same due date -->
              <v-flex xs12 v-if="doubleBookedVendorError && task.vendor_id">
                <v-alert :value="true" type="warning">*Note: This Vendor is already booked for the same date range:
                  <v-list class=" warning white--text" v-for="(vendors, index) in doubleBookedVendorError" :key="index">
                    Project: {{ vendors.projectName }} | Task: {{ vendors.taskName }} | Due Date: {{ vendors.dueDate.seconds | moment("dddd, MMMM Do YYYY") }}
                  </v-list>
                </v-alert>
              </v-flex>
              <!-- End: Identifies if the vendor is double booked on another project on the same due date -->
            </v-layout>
          </div>
        </v-flex>
      <!-- </v-layout> -->
      <!-- Checklists AND Task Notes-->
      <!-- <v-layout class="pt-3 layoutBox" row wrap pr3> -->
        <!-- Start: Checklists Items -->
        <v-flex xs12 sm6 style="max-height: 300px" class="scroll-y">
          <v-toolbar height="40px" color="primary">
            <v-icon dark>check_box</v-icon>
            <v-toolbar-title class="white--text">Checklist Items</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn v-if="canEdit" @click="showAddChecklist = true" dark icon><v-icon dark>add</v-icon></v-btn>
          </v-toolbar>
          <v-layout row wrap v-if="showAddChecklist">
            <v-flex xs12>
              <v-text-field :disabled="!canEdit" autofocus class="pl-4 title" v-model="newChecklistItem" label="Add New Item" prepend-icon="check_box"></v-text-field>
            </v-flex>
            <v-flex class="text-xs-right">
              <v-btn v-if="canEdit" @click="addNewChecklistItem" small class="primary">ADD</v-btn><v-btn @click="showAddChecklist = false" small class="secondary">CLOSE</v-btn>
            </v-flex>
          </v-layout>
          <v-list class="ml-4 title completed scroll-y" v-for="(checklist, index) in checklists" :key="index"> <!-- :class="{ 'completed': checklist.completed }" -->
            <v-layout row wrap>
              <v-flex>
                <v-checkbox :disabled="!canEdit" @change="checkListChange = true; updateCheckListItems(index)" v-model="checklist.completed" :label="checklist.name" />
              </v-flex>
              <v-flex class="text-xs-right">
                <v-icon v-if="canEdit" @click="removeChecklistItem(checklist.name)" style="cursor: pointer" light>cancel</v-icon>
              </v-flex>
            </v-layout>
            <v-divider></v-divider>
          </v-list>
          <p v-if="checklists.length < 1" class="ml-3 pt-3 subheading">There are no checklists for this task</p>
        </v-flex>
        <!-- End: Checklist Items -->
        <!-- Assigned Users and Notes -->
        <!-- Start: Assigned Users -->
        <v-flex xs12 sm6 pl-3>
          <v-toolbar height="40px" color="secondary" dark>
          <v-icon dark left>group</v-icon>
          <v-toolbar-title>Assigned Task Users</v-toolbar-title>
          <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-menu transition="slide-x-transition" bottom right>
            <v-btn v-if="canEdit" dark flat icon slot="activator"><v-icon>person_add</v-icon></v-btn>
              <v-list>
                <v-list-tile v-for="(user, i) in userList" :key="i" @click="assignUser(user)">
                  <v-avatar class="mr-3">
                    <avatar :size="36" :username="user.first_name + ' ' + user.last_name" :src="user.avatar ? user.avatar : undefined"></avatar>
                  </v-avatar>
                  <v-list-tile-title class="font-weight-strong">{{ user.first_name + ' ' + user.last_name }}</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-toolbar>
          <v-layout row wrap mt-3 ml-2 mb-3>
            <div v-if="assignedUsers.length > 0" v-for="(user, i) in assignedUsers" :key="i">
            <v-badge overlap color="grey" class="ml-2">
            <span v-if="canEdit" @click="removeAssignedUser(user)" style="cursor:pointer" slot="badge">X</span>
            <v-avatar>
              <v-tooltip top>
                <avatar slot="activator" :username="user.first_name + ' ' + user.last_name" :src="user.avatar ? user.avatar : undefined"></avatar>{{ user.first_name + ' ' + user.last_name }}
              </v-tooltip>
            </v-avatar>
            </v-badge>
            </div>
            <span class="ml-2" v-if="assignedUsers.length < 1">No Assigned Users</span>
          </v-layout>
          <!-- End: Assigned Users -->
          <!-- Notes -->
          <v-toolbar height="40px" color="secondary" dark>
            <v-icon dark left>library_books</v-icon>
            <v-toolbar-title>Task Notes</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn v-if="canEdit" @click="showNoteForm = true" icon>
              <v-icon>add</v-icon>
            </v-btn>
          </v-toolbar>
          <v-layout v-if="showNoteForm" row wrap>
            <v-flex xs12 pt-3 pl-3 pr-3>
              <v-textarea outline v-model="newNote" label="Add A New Note"></v-textarea>
            </v-flex>
            <v-flex xs12 pl-3>
              <v-checkbox class="mt-0 pt-0 pb-0" label="Notify Assigned Users" v-model="noteNotifyAssigned" />
              <v-checkbox class="mt-0 pt-0" label="Notify All Users" v-model="noteNotifyAll" />
            </v-flex>
            <v-layout ml-3 mb-3 row>
              <v-btn @click="addNote" class="primary">SAVE NOTE</v-btn>
              <v-btn @click="showNoteForm = false" class="secondary">CANCEL</v-btn>
            </v-layout>
          </v-layout>
          <v-divider v-if="showNoteForm" class="mb-3"></v-divider>
          <v-list three-line>
            <template v-for="(note, index) in taskNotes">
              <v-list-tile :key="index" avatar>
                <v-list-tile-avatar>
                  <v-avatar @click="showRightSideBar = !showRightSideBar" style="padding-top: 20px; cursor: pointer"><v-tooltip top><avatar slot="activator" :username="note.userFullName" :src="note.avatar ? note.avatar : undefined"></avatar>{{ note.userFullName }}</v-tooltip></v-avatar>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title class="primary--text font-weight-bold">{{ note.created_date.seconds | moment("from") }} {{ note.created_date.seconds | moment("MM/DD/YY") }}</v-list-tile-title>
                  <v-list-tile-sub-title class="black--text" v-html="note.note"></v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </template>
          </v-list>
          <p v-if="taskNotes.length < 1" class="ml-3 subheading">There are no notes for this task</p>
          <!-- End: Notes -->
        </v-flex>
      <!-- Upload Files -->
        <v-flex xs12 class="mt-3" v-if="!projectGrid">
          <v-toolbar dark class="secondary" height="50px">
            <v-icon v-if="task.required_upload || taskFiles.length > 0">{{ task.required_upload === 'Jobsite Photos' ? 'photo_camera' : task.required_upload === 'Pool Print' ? 'border_outer' : 'attachment' }}</v-icon>
            <v-toolbar-title>{{task.required_upload ? 'Required: ' + task.required_upload : taskFiles.length > 0 ? 'Task Files' : ''}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn v-if="canEdit && !showUploader" class="cyan" @click="showUploader = true">{{ task.required_upload === 'Jobsite Photos' ? 'Upload Photos' : task.required_upload === 'Pool Print' ? 'Upload Pool Print' : 'Upload Files' }}</v-btn>
            <v-btn v-if="canEdit && showUploader" class="cyan" @click="showUploader = false">Close Uploader</v-btn>
          </v-toolbar>
          <!-- If Pool Print -->
          <v-flex class="mt-4" xs12 pl-3 v-if="task.required_upload === 'Pool Print' && !plansUploaded">
            <v-checkbox class="mt-0 pt-0 pb-0" label="Notify Assigned Users" v-model="noteNotifyAssigned" />
            <v-checkbox class="mt-0 pt-0" label="Notify All Users" v-model="noteNotifyAll" />
          </v-flex>
          <!-- End: If Pool Print -->
          <project-files v-if="taskFiles.length > 0" :project="project" :taskFiles="taskFiles"/>
          <p v-if="photosUploaded" class="mt-4 pa-3 title success white--text">Photos Uploaded Successfully to the Jobsite Photos Section.</p>
          <p v-if="plansUploaded" class="mt-4 pa-3 title success white--text">Pool Print Uploaded Successfully to the Pool Print Section.</p>          
          <uploader v-if="showUploader" @planVersion="planVersion" @closeUploader="showUploader = false" :singleOnly="task.required_upload === 'Pool Print'" :photos="task.required_upload === 'Jobsite Photos'" :project="project" :task="task" :uploadPath="task.required_upload === 'Jobsite Photos' ? 'projects/' + this.project.id + '/photos/' : task.required_upload === 'Pool Print' ? 'projects/' + this.project.id + '/plans/' : 'projects/' + this.project.id + '/vault/'" @filesUploaded="uploadedFiles" />
        </v-flex>
        <v-flex xs12 class="mt-3 text-xs-center">
          <v-btn @click="closeDialog" color="secondary">CLOSE</v-btn>
        </v-flex>
      </v-layout>
    </v-card>
    <!-- Change Due Date Dialog -->
    <v-dialog v-if="showDueDateDialog" v-model="showDueDateDialog" width="400px">
      <v-toolbar dark class="secondary">
        <v-icon dark left>list</v-icon>
        <v-toolbar-title>Change Task Dependency</v-toolbar-title>
      </v-toolbar>
      <v-layout class="white" justify-center row pt-3 pb-3>
          <v-btn @click="showTaskDependencyDialog(), showDueDateDialog = false" class="primary"><v-icon style="margin-left: -8px; margin-right: 5px;" left dark>list</v-icon>Change Task Dependancy</v-btn>
      </v-layout>
      <v-toolbar dark class="secondary">
        <v-icon dark left>today</v-icon>
        <v-toolbar-title>Select Due Date</v-toolbar-title>
      </v-toolbar>
      <v-layout class="white" justify-center row pt-3>
        <v-date-picker v-model="datePicker"></v-date-picker>
      </v-layout>
      <v-layout class="white" row wrap justify-center>
        <v-btn @click="changeDueDate" class="primary"><v-icon style="margin-left: -8px; margin-right: 5px;" left dark>web_asset</v-icon>Change This Task Only (And Dependancies)</v-btn>
      </v-layout>  
      <v-layout class="white" row wrap justify-center>
        <v-btn @click="changeAllDates" class="primary"><v-icon style="margin-left: -8px; margin-right: 5px;" left dark>toc</v-icon>Change All Subsequent Tasks</v-btn>
      </v-layout>
      <v-layout class="white" pt-3 justify-center row>
        <v-btn @click="showDueDateDialog = false" class="secondary">CANCEL</v-btn>
      </v-layout>
    </v-dialog>
    <!-- End: Change Due Date Dialog -->
    <!-- Change All Dates? -->
    <v-dialog v-if="ifChangeAllDates" v-model="ifChangeAllDates" width="600px" height="400px">
      <v-toolbar dark class="secondary">
        <v-icon dark left>toc</v-icon>
      <v-toolbar-title>Change All Subsequent Tasks?</v-toolbar-title>
    </v-toolbar>
        <v-alert style="margin-top: -5px;" dark :value="true" color="info" icon="info">You are about to change all subsequent tasks <span class="subheading">{{dueDateTypeDifference}} {{dueDateDifference}}</span> day(s)... <br>Are you sure you want to continue?
          <v-layout mt-3>
            <v-btn @click="emitAllDateChanges" class="error">CHANGE SUBSEQUENT TASKS</v-btn>
            <v-btn @click="ifChangeAllDates = false" class="secondary">CANCEL</v-btn>
          </v-layout>
        </v-alert>
    </v-dialog>
    <!-- End: Change All Dates? -->
    <!-- Change Dependency Dialog -->
    <v-dialog v-if="changeDependencyDialog" v-model="changeDependencyDialog" width="600px">
      <v-toolbar dark class="secondary">
        <v-icon dark left>today</v-icon>
        <v-toolbar-title>Change Task Dependency</v-toolbar-title>
      </v-toolbar>
      <v-layout class="white" row wrap justify-space-between>
        <v-container>
          <v-layout row wrap>
            <v-flex xs12 md7>
              <v-select v-model="saveDependencyValues.execution" :items="execution" :rules="validationRequired" label="Task Starts" required prepend-icon="insert_invitation"></v-select>
            </v-flex>
            <v-flex xs12 md5>
              <v-text-field v-model="saveDependencyValues.days_due" :rules="validationRequired" :label="saveDependencyValues.after_task ? 'Days Due From Task Completion' : 'Days until Due From Start Date'" required prepend-icon="today"></v-text-field>
            </v-flex>
            <v-flex xs6 v-if="saveDependencyValues.execution === 'From Task Completion'">
              <v-select v-model="saveDependencyValues.after_task_name" :items="tasksDropDown" :rules="validationRequired" label="After This Task Completes:" required prepend-icon=" "></v-select>
            </v-flex>
          </v-layout>
          <v-layout justify-center row>
            <v-btn @click="saveTaskDependency" class="primary"><v-icon style="margin-left: -8px; margin-right: 5px;" left dark>web_asset</v-icon>Save Task</v-btn>
            <v-btn @click="changeDependencyDialog = false" class="secondary">CANCEL</v-btn>
          </v-layout>
        </v-container>
      </v-layout>
    </v-dialog>
    <!-- End: Change Due Date Dialog -->
    <!-- Vendor Search Dialog Box -->
    <v-dialog v-if="vendorSearch" v-model="vendorSearch" width="600px" height="400px">
      <vendor-search v-if="vendorSearch" @closeDialog="vendorSearch = false" @emittedVendor="emittedVendor" :project="project" :task="task" />
    </v-dialog>
    <!-- End: Vendor Search Dialog Box -->
  </div>
</template>

<script>
import _ from 'lodash'
import Avatar from 'vue-avatar'
import VendorSearch from '../vendors/VendorSearch'
import Uploader from '../../helpers/Uploader'
import ProjectFiles from '../projects/ProjectFiles'
export default {
  props: ['taskId', 'taskIndex', 'project', 'projectNotes', 'selectedTask', 'projectGrid', 'taskName', 'tasks'],
  data () {
    return {
      saveDependencyValues: null,
      changeDependencyDialog: false,
      ifChangeAllDates: false,
      noteNotifyAll: false,
      noteNotifyAssigned: false,
      plansUploaded: false,
      photosUploaded: false,
      uploadedFileList: [],
      fileVersion: null,
      showUploader: false,
      checkListChange: false,
      selectTask: null,
      vendorSearch: false,
      showAddChecklist: false,
      newChecklistItem: null,
      newNote: null,
      showNoteForm: false,
      datePicker: null,
      showDueDateDialog: false,
      validationRequired: [
        v => !!v || 'Field is required'
      ]
    }
  },
  watch: {
    noteNotifyAssigned () {
      if (this.noteNotifyAssigned) {
        this.noteNotifyAll = false
      }
    },
    noteNotifyAll () {
      if (this.noteNotifyAll) {
        this.noteNotifyAssigned = false
      }
    }
  },
  mounted () {
    if (!this.projectGrid && this.task.required_upload && this.task.status !== 'Completed' && this.canEdit) {
      this.showUploader = true
    }
    if (this.taskName) {
      this.$store.dispatch('getProjectTask', {projectId: this.project.id, taskName: this.taskName})
    }
    // If project tasks are not present (needed for dependancies - then get them)
    if (!this.tasks && this.task) {
      this.$store.dispatch('getProject', this.task.projectId)
    }
  },
  destroyed () {
    this.saveAndClose()
  },
  computed: {
    projectTasks () {
      // If tasks are missing (i.e. from scheduler - then retrieve them)
      const getProject = this.$store.getters.getProject
      if (this.tasks) {
        return this.tasks
      }
      if (!this.tasks && getProject && getProject.tasks) {
        let projectTasks = []
        const taskKeys = Object.keys(getProject.tasks)
        taskKeys.forEach(key => {
          projectTasks.push({ id: key, ...getProject.tasks[key] })
        })
        return projectTasks
      } else {
        return null
      }
    },
    tasksDropDown () {
      let taskList = this.projectTasks
      taskList = taskList.filter(f => f.id !== this.task.id)
      let items = []
      let taskOrder = _.orderBy(taskList, ['order', 'name'])
      taskOrder.forEach(item => {
        if (item.deleted !== true) {
          items.push({ text: item.name, value: item.taskId })
        }
      })
      return items
    },
    execution () {
      return (this.projectTasks && this.projectTasks.length > 0) ? ['From Start Date', 'From Task Completion'] : ['From Start Date']
    },
    doubleBookedVendorError () {
      return this.$store.getters.getDoubleBookedVendor
    },
    userList () {
      return _.orderBy(this.$store.getters.userList, 'first_name')
    },
    assignedUsers () {
      let assigned = []
      if (this.task.assigned_to) {
        this.task.assigned_to.forEach(user => {
          assigned.push(this.$store.getters.userList.concat(this.$store.getters.inactiveUsers).filter(f => f.id === user)[0])
        })
        return assigned
      } else {
        return assigned
      }
    },
    dueDateDifference () {
      const date1 = new Date(this.$moment(this.datePicker).add(23, 'hours'))
      const date2 = new Date(this.task.due_date.seconds * 1000)
      const diffTime = date1.getTime() - date2.getTime()
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
      return diffDays
    },
    dueDateTypeDifference () {
      if (this.dueDateDifference >= 0) {
        return 'FORWARD'
      } else {
        return 'BACK'
      }
    },
    canEdit () {
      return this.permissions.edit.all || (this.permissions.edit.assigned && this.project.assigned)
    },
    permissions () {
      return this.$store.getters.user.permissions.projects
    },
    taskFiles () {
      const files = this.$store.getters.projectFiles
      return _.filter(files, {task_id: this.taskId})
    },
    cannotComplete () {
      if (this.task.required_upload && this.task.required_upload !== 'Jobsite Photos' && this.task.required_upload !== 'Pool Print') {
        return this.checklists.filter(f => !f.completed && f.active).length > 0 || this.taskFiles.length < 1
      } else if (this.task.required_upload === 'Jobsite Photos') {
        return this.checklists.filter(f => !f.completed && f.active).length > 0 || this.photosUploaded === false
      } else if (this.task.required_upload === 'Pool Print') {
        return this.checklists.filter(f => !f.completed && f.active).length > 0 || this.plansUploaded === false
      } else {
        return this.checklists.filter(f => !f.completed && f.active).length > 0
      }
    },
    user () {
      return this.$store.getters.user
    },
    task () {
      if (this.taskName) {
        const theTask = this.$store.getters.getProjectTask
        if (theTask.is_double_booked) {
          this.checkVendorDoubleBooking(theTask.id, theTask.is_double_booked, theTask.vendor_id, theTask.due_date)
        }
        console.log('Opened Task: ', theTask)
        return theTask
      } else if (this.selectedTask) {
        if (this.selectedTask.is_double_booked) {
          this.checkVendorDoubleBooking(this.selectedTask.id, this.selectedTask.is_double_booked, this.selectedTask.vendor_id, this.selectedTask.due_date)
        }
        console.log('Opened Task: ', this.selectedTask)
        return this.selectedTask
      } else {
        let getTask = _.filter(this.$store.getters.projectTasks, {id: this.taskId})[0]
        if (getTask) {
          if (!getTask.assigned_to) {
            getTask = { ...getTask, assigned_to: [] }
          }
          if (getTask.is_double_booked) {
            this.checkVendorDoubleBooking(getTask.id, getTask.is_double_booked, getTask.vendor_id, getTask.due_date)
          }
          // If from scheduler then we need to add after_task_name
          if (!this.tasks) {
            if (getTask.after_task && this.projectTasks && this.projectTasks.length > 0) {
              const afterTask = this.projectTasks.filter(f => f.id === getTask.after_task)[0]
              getTask.after_task_name = afterTask.name
            }
          }
          if (this.getProjectTasks) { console.log('Project Loaded') }
          console.log('Opened Task: ', getTask)
          return getTask
        }
      }
    },
    userFullName () {
      return this.user.first_name + ' ' + this.user.last_name
    },
    taskNotes () {
      const notes = _.filter(this.projectNotes, {task_name: this.task.name})
      return _.orderBy(notes, 'date_created', ['Desc'])
    },
    checklists () {
      return _.filter(this.task.checklist, {active: true})
    }
  },
  methods: {
    saveTaskDependency () {
      const projectStartDate = new Date(this.project.start_date.seconds * 1000)
      if (this.saveDependencyValues.execution !== 'From Start Date') {
        let taskList = this.projectTasks
        const afterTask = taskList.filter(f => f.name === this.saveDependencyValues.after_task_name)[0]
        const startDate = new Date(afterTask.due_date.seconds * 1000)
        const dueDate = new Date(afterTask.due_date.seconds * 1000)
        dueDate.setDate(dueDate.getDate() + parseInt(this.saveDependencyValues.days_due))
        const payload = [ { id: this.task.id, after_task: afterTask.id, execution: 'From Task Completion', days_due: this.saveDependencyValues.days_due, start_date: startDate, due_date: dueDate } ]
        this.$store.dispatch('editTask', payload)
      } else {
        const dueDate = new Date(this.project.start_date.seconds * 1000)
        dueDate.setDate(projectStartDate.getDate() + parseInt(this.saveDependencyValues.days_due))
        const payload = [ { id: this.task.id, after_task: null, execution: 'From Start Date', days_due: this.saveDependencyValues.days_due, start_date: projectStartDate, due_date: dueDate } ]
        this.$store.dispatch('editTask', payload)
      }
      this.changeDependencyDialog = false
    },
    showTaskDependencyDialog () {
      // Set Default Dependency Values
      this.saveDependencyValues = { execution: this.task.execution, after_task: this.task.after_task, after_task_name: this.task.after_task_name, days_due: this.task.days_due }
      this.changeDependencyDialog = true
    },
    saveAndClose () {
      // Save Double Booked Vendors If They Apply
      if (!this.task.is_double_booked && this.doubleBookedVendorError) {
        let doubleBooked = [{ id: this.task.id, is_double_booked: true }]
        this.doubleBookedVendorError.forEach(task => {
          doubleBooked.push({ id: task.taskId, is_double_booked: true })
        })
        this.$store.dispatch('editTask', doubleBooked)
      }
      if (this.task.is_double_booked && !this.doubleBookedVendorError) {
        this.$store.dispatch('editTask', [ { id: this.task.id, is_double_booked: false } ])
      }
      if (this.checkListChange === true) {
        const payload = {task: this.task, project: this.project, checklists: this.checklists}
        this.$store.dispatch('updateCheckListItems', payload)
        this.$store.dispatch('updateFilteredTasks', this.task)
      }
      // Things that need to happen everytime the task window closes
      this.$store.commit('checkVendorDoubleBooked', null)
    },
    checkVendorDoubleBooking (taskId, isDoubleBooked, vendorId, dueDate) {
      if (vendorId) {
        const payload = { taskId, isDoubleBooked, vendorId, dueDate: new Date(dueDate.seconds * 1000) }
        this.$store.dispatch('checkVendorDoubleBooked', payload)
      } else {
        this.$store.commit('checkVendorDoubleBooked', null)
      }
    },
    removeAssignedUser (user) {
      if (confirm('Are you sure you want to remove the assigned user: ' + user.first_name + ' ' + user.last_name + '?')) {
        const index = this.task.assigned_to.findIndex(i => i === user.id)
        this.task.assigned_to.splice(index, 1)
        if (this.task.assigned_to.length < 1) { this.task.assigned_to = null }
        this.$store.dispatch('editTask', [{ id: this.task.id, assigned_to: this.task.assigned_to }])
        // this.$store.dispatch('removeAssignedTaskUser', { project: this.project, task: this.task, user: user })
      }
    },
    assignUser (user) {
      this.task.assigned_to.push(user.id)
      this.$store.dispatch('assignTaskUser', { project: this.project, task: this.task, user: user })
    },
    planVersion (newPlanVersion) {
      this.fileVersion = newPlanVersion
    },
    uploadedFiles (files) {
      if (this.task.required_upload === 'Jobsite Photos') {
        this.getUploadPhotos(files)
      } else if (this.task.required_upload === 'Pool Print') {
        this.getUploadPlans(files)
        this.poolPrintNotify()
      } else {
        this.getUploadFiles(files)
      }
    },
    poolPrintNotify () {
      // Send Notifications if Any
      if (this.noteNotifyAll || this.noteNotifyAssigned) {
        let emails = []
        // Get Notification Emails
        let users = Object.assign([], this.$store.getters.userList)
        // Filter Out The Current User
        users.splice(users.findIndex(i => i.id === this.$store.getters.user.id), 1)
        if (this.noteNotifyAll) {
          emails = users.map(user => user.email)
        }
        if (this.noteNotifyAssigned) {
          this.project.assigned_to.forEach(assigned => {
            const userEmail = users.filter(f => f.id === assigned)[0]
            if (userEmail) {
              emails.push(userEmail.email)
            }
          })
        }
        if (emails.length > 0) {
          const emailSubject = 'New Pool Plan For Project: ' + this.project.name
          const title = this.user.first_name + ' ' + this.user.last_name + ' Added A New Pool Plan To The Project: ' + this.project.name
          const message = 'There is a new pool plan for the project: ' + this.project.name + ' (Revision: ' + this.fileVersion + ' ). Make sure you have the latest.'
          const url = this.$store.getters.clientSettings.baseUrl + '/project/' + this.project.id
          const icon = 'border_outer'
          this.$store.dispatch('notify', {emails, emailSubject, title, message, url, icon})
          this.noteNotifyAll = false
          this.noteNotifyAssigned = false
        }
      }
    },
    getUploadFiles (files) {
      this.uploadedFileList = []
      files.forEach(value => {
        let selectedFileName = value.ref.name.replace(/\.[^/.]+$/, '')
        let selectedFileExtension = value.ref.name.split('.').pop()
        this.uploadedFileList.push({id: this.project.id, name: selectedFileName, type: value.metadata.contentType, extension: selectedFileExtension, path: value.ref.fullPath, timestamp: new Date(), created_by: this.user.id, active: true, task_id: this.task.id})
      })
      const payload = {id: this.project.id, project_name: this.project.name, files: this.uploadedFileList, task_id: this.task.id}
      this.$store.dispatch('projectFiles', payload)
    },
    getUploadPhotos (files) {
      this.uploadedFileList = []
      files.forEach(value => {
        if (value.ref.name.startsWith('thumb')) {
          return
        }
        let selectedFileName = value.ref.name
        this.uploadedFileList.push({id: this.project.id, name: selectedFileName, thumbnail: 'thumb_' + selectedFileName, type: value.metadata.contentType, path: value.ref.fullPath, timestamp: new Date(), created_by: this.user.id, active: true})
      })
      const payload = {id: this.project.id, project_name: this.project.name, files: this.uploadedFileList}
      this.$store.dispatch('projectPhotos', payload)
      this.photosUploaded = true
    },
    getUploadPlans (files) {
      this.uploadedFileList = []
      files.forEach(value => {
        let selectedFileExtension = value.ref.name.split('.').pop()
        this.uploadedFileList.push({project_id: this.project.id, name: this.fileVersion, type: value.metadata.contentType, extension: selectedFileExtension, path: value.ref.fullPath, timestamp: new Date(), created_by: this.user.id, active: true})
        const payload = {project_id: this.project.id, project_name: this.project.name, files: this.uploadedFileList}
        this.$store.dispatch('newProjectPlan', payload)
        this.plansUploaded = true
      })
    },
    completeTask () {
      // if (this.taskName) {
      //   this.task.status = 'Completed'
      //   this.$emit('completeTask', {projectName: this.project.name, taskName: this.taskName})
      // }
      const payload = { task: this.task, project: this.project, status: 'Completed' }
      this.$store.dispatch('completeTask', payload)
      this.saveAndClose()
      this.closeDialog()
    },
    updateCheckListItems (index) {
      if (!this.checklists[index].completed_date) {
        this.checklists[index].completed_date = new Date()
        this.checklists[index].completed_by = this.user.id
      } else {
        this.checklists[index].completed_date = null
        this.checklists[index].completed_by = null
      }
    },
    // Added as VUEX is not automatically changing the task object // Found out it needs to be watching the vendor_id which isn't automatically created. Refactor.
    emittedVendor (vendor) {
      this.checkVendorDoubleBooking(this.task.id, this.task.is_double_booked, vendor.id, this.task.due_date)
    },
    removeVendor () {
      const payload = {task: this.task, project: this.project, vendor: this.task.vendor_name}
      this.$store.dispatch('removeVendorFromTask', payload)
      this.$store.dispatch('updateFilteredTasks', this.task)
      this.$store.commit('checkVendorDoubleBooked', null)
    },
    statusDropDown (task) {
      if (task.if_na === true) {
        return ['Not Started', 'Started', 'On Hold', 'Flagged', 'Not Applicable']
      } else {
        return ['Not Started', 'Started', 'On Hold', 'Flagged']
      }
    },
    removeChecklistItem (item) {
      const payload = {project: this.project, task: this.task, checklistItem: item}
      this.$store.dispatch('removeChecklistItem', payload)
      this.$store.dispatch('updateFilteredTasks', this.task)
    },
    addNewChecklistItem () {
      const payload = {project: this.project, task: this.task, checklistItem: this.newChecklistItem}
      this.$store.dispatch('addNewChecklistItem', payload)
      this.$store.dispatch('updateFilteredTasks', this.task)
      this.newChecklistItem = null
    },
    closeDialog () {
      this.$emit('closeTaskDialog')
    },
    statusActivate (task) {
      this.selectTask = Object.assign({}, task)
    },
    taskExecution (status) {
      if (status === 'Not Applicable') {
        const payload = { task: this.task, project: this.project, status: status }
        this.$store.dispatch('completeTask', payload)
      } else {
        const payload = { id: this.task.id, status: status }
        this.$store.dispatch('editTask', payload)
      }
    },
    addNote () {
      let payload = {task_id: this.task.id, task_name: this.task.name, note: this.newNote, phase: this.project.status}
      if (this.noteNotifyAll || this.noteNotifyAssigned) {
        payload = {...payload, flagged: this.noteNotifyAssigned ? 'Notified Assigned Users' : 'Notified All Users'}
      }
      this.$emit('addNote', payload)
      this.showNoteForm = false
    },
    changeDueDate () {
      if (!this.datePicker) {
        alert('You have not yet selected a new date. Please select a date and try again.')
      } else {
        let taskList = []
        const newDueDate = new Date(this.$moment(this.datePicker).add(23, 'hours'))
        // Push Target Task
        taskList.push({ task: this.task, newDueDate: newDueDate })
        // Push Dependant Tasks
        let dependantTasks = this.projectTasks.filter(f => f.after_task === this.task.id)
        dependantTasks.map(m => (taskList.push({ task: m, newDueDate: this.$moment(newDueDate).add(m.days_due, 'days').toDate() })))
        this.$store.dispatch('changeTaskDates', taskList)
        this.datePicker = null
        this.showDueDateDialog = false
      }
    },
    changeAllDates () {
      if (!this.datePicker) {
        alert('You have not yet selected a new date. Please select a date and try again.')
      } else {
        this.ifChangeAllDates = true
        this.showDueDateDialog = false
      }
    },
    emitAllDateChanges () {
      this.ifChangeAllDates = false
      let shiftTasks = this.projectTasks.filter(f => f.active === true && f.due_date.seconds >= this.projectTasks[this.taskIndex].due_date.seconds)
      shiftTasks = shiftTasks.map(m => ({ task: m, newDueDate: this.$moment(new Date(m.due_date.seconds * 1000)).add(this.dueDateDifference, 'days').toDate() }))
      this.$store.dispatch('changeTaskDates', shiftTasks)
      this.datePicker = null
      this.showDueDateDialog = false
    },
    statusColors () {
      if (this.task) {
        if (this.task.status === 'Flagged') {
          return ['Flagged', 'white--text']
        } else if (this.task.status === 'Completed') {
          return ['Completed', 'white--text']
        } else if (this.task.status === 'Not Applicable') {
          return ['secondary', 'white--text']
        } else if (this.task.status === 'On Hold') {
          return ['OnHold', 'black--text']
        } else if (this.task.due_date.seconds < new Date().getTime() / 1000) {
          return ['PastDue', 'white--text']
        } else if (this.task.status === 'Not Started') {
          return ['NotStarted', 'white--text']
        } else if (this.task.status === 'Started') {
          return ['Started', 'white--text']
        }
      }
    },
    statusBorders () {
      if (this.task.status === 'Flagged') {
        return this.$vuetify.theme.Flagged
      } else if (this.task.status === 'Completed') {
        return this.$vuetify.theme.Completed
      } else if (this.task.status === 'Not Applicable') {
        return this.$vuetify.theme.secondary
      } else if (this.task.status === 'On Hold') {
        return this.$vuetify.theme.OnHold
      } else if (this.task.due_date.seconds < new Date().getTime() / 1000) {
        return this.$vuetify.theme.PastDue
      } else if (this.task.status === 'Not Started') {
        return this.$vuetify.theme.NotStarted
      } else if (this.task.status === 'Started') {
        return this.$vuetify.theme.Started
      }
    }
  },
  components: {
    Avatar,
    VendorSearch,
    Uploader,
    ProjectFiles
  }
}
</script>

<style scoped>
label {
  text-decoration: line-through;
}
.iconTextBox {
  color: white;
  margin-right: 15px;
  margin-left: 15px;
  border-radius: 5px;
  background-color: rgba(0, 0, 0, 0.5);
  font-weight: 900;
}
.boxToolbar {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.layoutBox {
  background-color: #fafafa;
  padding-top: 10px;
  padding-left: 10px;
  padding-right: 10px;
  padding-bottom: 30px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}
.completed {
  color: #4caf50;
  font-size: 16px;
}
.pastDue {
  color: red;
  font-size: 16px;
}
.currentDue {
  color: orange;
  font-size: 16px;
}
.notDue {
  color: green;
  font-size: 16px;
}
</style>




// WEBPACK FOOTER //
// src/components/tasks/EditTask.vue